import './PageTopNav.css';

import React from 'react';

import BackButton from '../BackButton/BackButton';
import VideoUploadNavIndicator from '../VideoUploadNavIndicator/VideoUploadNavIndicator';

interface PageTopNavProps {
  title: string;
  onBack: () => void;
  backAriaLabel: string;
  rightSlot?: React.ReactNode;
}

const PageTopNav: React.FC<PageTopNavProps> = ({
  title,
  onBack,
  backAriaLabel,
  rightSlot,
}) => (
  <header className="page-top-nav">
    <BackButton onClick={onBack} ariaLabel={backAriaLabel} />
    <h1 className="page-top-nav__title">{title}</h1>
    <div className="page-top-nav__right">
      <VideoUploadNavIndicator />
      {rightSlot}
    </div>
  </header>
);

export default PageTopNav;
